import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

export async function getPantry(householdId){
  const snap = await getDoc(doc(db, "pantry", householdId));
  return snap.exists() ? snap.data().items || [] : [];
}

export async function savePantry(householdId, items){
  await setDoc(doc(db, "pantry", householdId), { items });
}
